<template>
  <a-popover :visible="state.sVisible"
             trigger="click"
             v-bind="$attrs"
             :overlay-class-name="overlayClassName"
             placement="bottom"
             @visibleChange=";"
             v-on="$attrs">
    <template #content>
      <div class="title-content">
      </div>
      <slot name="formContent" />
      <div class="uranus-popconfirm-btns">
        <a-button size="sm"
           @click="onCancel">
           {{ cancelText || '取消'}}
        </a-button>
        <a-button size="sm"
          :loading="loading"
          type="primary"
          class="confirm-btn"
          @click="onConfirm">
          {{ okText || '确定' }}
        </a-button>
      </div>
    </template>
    <template v-if="$slots.default">
      <slot></slot>
    </template>
  </a-popover>
</template>

<script lang="ts" setup>
import { defineProps, defineEmits, reactive, watch, computed } from 'vue'

const props = defineProps<{
    visible?: boolean,
    loading?: Boolean,
    disabled?: Boolean,
    title?: String,
    okText?: String,
    cancelText?: String,
    width?: Number,
}>()

const emit = defineEmits(['cancel', 'confirm'])

const state = reactive({
  sVisible: false,
  loading: false,
})

watch(() => props.visible, (val) => {
  state.sVisible = val || false
})

const loading = computed(() => {
  return props.loading
})
const okLabel = computed(() => {
  return props.loading ? '' : '确定'
})

const overlayClassName = computed(() => {
  const classList = ['device-setting-popconfirm']
  return classList.join(' ')
})

function onConfirm (e: Event) {
  if (props.disabled) {
    return
  }
  emit('confirm', e)
}

function onCancel (e: Event) {
  state.sVisible = false
  emit('cancel', e)
}

</script>

<style lang="scss">
.device-setting-popconfirm {
  min-width: 300px;

  .ant-popover-inner {
    background: linear-gradient(135deg, rgba(15, 15, 15, 0.98) 0%, rgba(20, 20, 20, 0.98) 100%) !important;
    backdrop-filter: blur(20px);
    border: 1px solid rgba(10, 132, 255, 0.3);
    border-radius: 8px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.6);
  }

  .ant-popover-inner-content {
    padding: 12px;
  }

  .ant-popover-arrow {
    display: none;
  }

  .uranus-popconfirm-btns{
    display: flex;
    padding: 10px 0px;
    justify-content: flex-end;
    gap: 10px;

    .ant-btn {
      background: rgba(10, 132, 255, 0.15);
      border: 1px solid rgba(10, 132, 255, 0.3);
      color: rgba(255, 255, 255, 0.9);
      border-radius: 6px;
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

      &:hover {
        background: rgba(10, 132, 255, 0.25);
        border-color: rgba(10, 132, 255, 0.5);
        color: #fff;
      }
    }

    .confirm-btn {
      margin-left: 0;
      background: linear-gradient(135deg, #0a84ff 0%, #0077ed 100%);
      border: 1px solid rgba(10, 132, 255, 0.5);
      color: #fff;

      &:hover {
        background: linear-gradient(135deg, #0077ed 0%, #006dd9 100%);
        box-shadow: 0 4px 12px rgba(10, 132, 255, 0.4);
      }

      &:active {
        transform: scale(0.98);
      }
    }
  }

  .form-content{
    display: inline-flex;
    align-items: center;
    padding: 8px;
    background: linear-gradient(135deg, rgba(10, 132, 255, 0.15) 0%, rgba(10, 132, 255, 0.08) 100%);
    border-radius: 6px;
    border: 1px solid rgba(10, 132, 255, 0.2);
    width: 100%;

    .form-label{
      padding-right: 10px;
      color: rgba(255, 255, 255, 0.9);
      font-weight: 500;
      white-space: nowrap;
    }

    .ant-switch {
      background-color: rgba(120, 120, 128, 0.32);
      
      &.ant-switch-checked {
        background-color: #0a84ff;
      }

      &:hover:not(.ant-switch-disabled) {
        background-color: rgba(120, 120, 128, 0.45);
      }

      &.ant-switch-checked:hover:not(.ant-switch-disabled) {
        background-color: #0077ed;
      }
    }

    .ant-input-number {
      background: rgba(10, 132, 255, 0.1);
      border: 1px solid rgba(10, 132, 255, 0.3);
      color: rgba(255, 255, 255, 0.9);
      border-radius: 6px;

      .ant-input-number-input {
        color: rgba(255, 255, 255, 0.9);
        background: transparent;
      }

      .ant-input-number-handler-wrap {
        background: rgba(10, 132, 255, 0.1);
        border-left: 1px solid rgba(10, 132, 255, 0.3);
      }

      .ant-input-number-handler {
        border-color: rgba(10, 132, 255, 0.2);
        color: rgba(255, 255, 255, 0.7);

        &:hover {
          color: rgba(255, 255, 255, 0.9);
        }
      }

      &:hover,
      &:focus,
      &.ant-input-number-focused {
        border-color: rgba(10, 132, 255, 0.5);
        box-shadow: 0 0 0 2px rgba(10, 132, 255, 0.15);
      }
    }
  }
}
</style>
